
import {Component, Vue} from "vue-property-decorator";


@Component
export default class HomeClass extends Vue {


    public activeIndex: number = 0;


    mounted() {
        console.log(this.$route.query.type);
        window.scrollTo(0, 0);
        const t = this.$route.query.type;
        if (t === '3-1') {
            this.activeIndex = 0;
        }

        if (t === '3-2') {
            this.activeIndex = 1;
        }

        if (t === '3-3') {
            this.activeIndex = 2;
        }
        if (t === '3-4') {
            this.activeIndex = 3;
        }

        if (t === '3-5') {
            this.activeIndex = 4;
        }


    }

    public tabClick(index: number) {
        this.activeIndex = index;
    }

}
